import $ from 'jquery';
import './Libraries/LFM/Menu';
import 'hoverIntent';

$('.navigation__list--level1').menu({desktop: 1340});


var hideTimeout;
$('.navigation__page--level1').hoverIntent({
    over: function () {
        $(this).closest('.header').addClass('header--open-submenu');
        $(this).siblings().removeClass('navigation__page--hover');
        $(this).addClass('navigation__page--hover');
    },
    interval: 100
})

$('.navigation__page--level1').on('mouseenter',function () {
    clearTimeout(hideTimeout)
})

$('.header').on('mouseleave', function () {
    $('.navigation__page--level1').removeClass('navigation__page--hover');
    $('.header').removeClass('header--open-submenu');
})
